import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, unref as _unref, withCtx as _withCtx, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "link-button__text" }
const _hoisted_2 = ["textContent"]

import FaIcon, { type FontAwesomeIcon } from '@lmt-rpb/Atoms/FaIcon/FaIcon.vue';
import { computed } from 'vue';
import { vTouchTarget } from 'src/directives/TouchTarget/touchTarget';

export interface Props {
	/**
	 * The HTML element to render as. Defaults to 'button'.
	 */
	as?: 'a' | 'button';
	/**
	 * The text to display inside the button.
	 */
	label?: string;
	/**
	 * Whether to show the icon. Defaults to true.
	 */
	withIcon?: boolean;
	/**
	 * The theme of the button. Can be `primary` or `inherit`. Defaults to `primary`.
	 */
	theme?: 'primary' | 'inherit';
	/**
	 * Whether the button text should be bold and `1.6rem` `font-size`. Defaults to `false`.
	 */
	bold?: boolean;
	/**
	 * A number or string to display as a badge.
	 * This will replace the icon if provided.
	 */
	badgeText?: string | number;
	/**
	 * The `FontAwesome` icon to display. If provided, it will replace the default icon.
	 * Defaults to `['fa-solid', 'fa-chevron-right']`.
	 */
	icon?: FontAwesomeIcon;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'LinkButton',
  props: {
    as: { default: 'button' },
    label: {},
    withIcon: { type: Boolean, default: true },
    theme: { default: 'primary' },
    bold: { type: Boolean, default: false },
    badgeText: { default: '' },
    icon: { default: () => (['fa-solid', 'fa-chevron-right']) }
  },
  setup(__props: any) {



const defaults = computed(() => (__props.as === 'button' ? { type: 'button' } : {}));
const blockClassModifiers = computed(() => ({
	[`link-button--${__props.theme}`]: __props.theme,
	['link-button--bold']: __props.bold,
	['link-button--with-badge']: !!__props.badgeText,
}));

return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.as), _mergeProps({
    class: ['link-button', blockClassModifiers.value]
  }, defaults.value), {
    default: _withCtx(() => [
      _createElementVNode("span", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", {}, () => [
          _createTextVNode(_toDisplayString(_ctx.label), 1 /* TEXT */)
        ])
      ]),
      (_ctx.withIcon && !_ctx.badgeText)
        ? (_openBlock(), _createBlock(FaIcon, {
            key: 0,
            class: "link-button__icon",
            icon: _ctx.icon
          }, null, 8 /* PROPS */, ["icon"]))
        : _createCommentVNode("v-if", true),
      (_ctx.badgeText?.toString().trim())
        ? (_openBlock(), _createElementBlock("small", {
            key: 1,
            class: "link-button__badge",
            textContent: _toDisplayString(_ctx.badgeText)
          }, null, 8 /* PROPS */, _hoisted_2))
        : _createCommentVNode("v-if", true)
    ]),
    _: 3 /* FORWARDED */
  }, 16 /* FULL_PROPS */, ["class"])), [
    [_unref(vTouchTarget)]
  ])
}
}

})